import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Rarity } from '__generated__/globalTypes';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { GemIcon } from 'atoms/icons/GemIcon';
import { Plus } from 'atoms/icons/Plus';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { proxyUrl } from 'atoms/ui/ResponsiveImg';
import { DialogKey } from 'components/navigation/WithDialogs';
import { ANY_SPORT_MARKET } from 'constants/__generated__/routes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';
import { useOpenDialog } from 'hooks/navigation/useOpenDialog';
import { getRewardImageUrl } from 'lib/rewards';

const BalanceButton = styled(ButtonBase)`
  border-radius: var(--unit);
  padding: var(--half-unit) var(--intermediate-unit);
  background: var(--c-nd-50);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--half-unit);
  &:hover,
  &:focus {
    background: var(--c-nd-200);
  }
  & svg {
    width: var(--unit);
    height: var(--unit);
  }
`;

const PlusIcon = styled(Horizontal).attrs({ gap: 0, center: true })`
  background-color: var(--c-blue-400);
  border-radius: 50%;
  width: var(--intermediate-unit);
  height: var(--intermediate-unit);
  outline: 1px solid var(--c-nd-50-opaque);
  margin-left: -7px;
`;

// TODO:  get active card set from API
const ACTIVE_CARD_SET_SLUG = 'winter';

export const MobileSeriesUserCurrencies = () => {
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const openDialog = useOpenDialog();

  const shardsBalance = currentUser?.cardShardsChests?.find(
    ({ rarity: chestRarity, cardSet }) =>
      chestRarity === Rarity.common &&
      // TODO:  get active card set from API
      cardSet?.slug === ACTIVE_CARD_SET_SLUG
  )?.cardShardsCount;
  return (
    <Horizontal>
      <BalanceButton onClick={() => openDialog(DialogKey.buyGems, 'true')}>
        <LabelM bold>
          <FormattedNumber value={currentUser?.gemsBalances[0]?.amount || 0} />
        </LabelM>
        <GemIcon size={1.5} />
        <PlusIcon>
          <Plus fill="white" />
        </PlusIcon>
      </BalanceButton>
      <BalanceButton as={Link} to={generateSportContextPath(ANY_SPORT_MARKET)}>
        <LabelM bold>
          <FormattedNumber value={shardsBalance || 0} />
        </LabelM>
        <img
          src={proxyUrl(
            getRewardImageUrl('shard', Rarity.common, ACTIVE_CARD_SET_SLUG),
            {
              cropWidth: 80,
            }
          )}
          alt=""
          width={16}
          height={16}
        />
      </BalanceButton>
    </Horizontal>
  );
};
